import { FunctionComponent } from 'react'
import {
  rucksack,
  Box,
  Skeleton,
  Typography,
} from '@black-bear-energy/rucksack'

export const FieldValue: FunctionComponent<FieldValueProps> = ({
  children,
  variant = 'body1',
  isPending = false,
}) => {
  // If the field value is pending, show a skeleton.
  if (isPending) {
    return <Skeleton width={100} />
  }

  // If the field value is null, undefined, or an empty string, show an em dash.
  const content =
    children === null || children === undefined || children === ''
      ? '—'
      : children

  // Use Typography for strings and numbers.
  if (typeof content === 'string' || typeof content === 'number') {
    return (
      <Typography variant={variant} color={rucksack.palette.text.secondary}>
        {content}
      </Typography>
    )
  }

  // Use Box for other kinds of React nodes.
  return <Box>{content}</Box>
}

interface FieldValueProps {
  children?: React.ReactNode
  variant?: 'body1'
  isPending?: boolean
}
